/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface LanguageIdentificationConfig
 */
export interface LanguageIdentificationConfig {
  /**
   *
   * @type {string}
   * @memberof LanguageIdentificationConfig
   */
  default_language?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof LanguageIdentificationConfig
   */
  expected_languages?: Array<string>;
  /**
   * Action to take if all of the predicted languages are below the confidence threshold
   * @type {string}
   * @memberof LanguageIdentificationConfig
   */
  low_confidence_action?: LanguageIdentificationConfigLowConfidenceActionEnum;
}

export const LanguageIdentificationConfigLowConfidenceActionEnum = {
  Allow: 'allow',
  Reject: 'reject',
  UseDefaultLanguage: 'use_default_language',
} as const;

export type LanguageIdentificationConfigLowConfidenceActionEnum =
  typeof LanguageIdentificationConfigLowConfidenceActionEnum[keyof typeof LanguageIdentificationConfigLowConfidenceActionEnum];
